

import { Component, Injector, inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputOtpModule } from 'primeng/inputotp';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseClass } from '../../shared/class/BaseClass';

@Component({
  selector: 'notchmark-verify-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonModule, InputOtpModule],
  providers: [DialogService],
  templateUrl: './verify-modal.component.html',
  styleUrls: ['./verify-modal.component.scss']
})
export class VerifyModalComponent extends BaseClass {
  private fb = inject(FormBuilder);
  private config = inject(DynamicDialogConfig);
  private ref = inject(DynamicDialogRef); 

  otpForm: FormGroup = this.fb.group({
    otp: ['', [Validators.required, Validators.pattern(/^\d+$/), Validators.minLength(4)]],
  });

  otpTimer = 60;
  resendEnabled = false;

  get payload() {
    // normalized payload from parent
    return this.config.data || {};
  }

  constructor(injector: Injector) {
    super(injector);
    this.startTimer();
  }

  closeDialog() { this.ref.close(); }

  // resendOtp() {
  //   const p: any = {};
  //   if (this.payload.email) p.email = this.payload.email;
  //   if (this.payload.phone) { p.phone = this.payload.phone; p.countryCode = this.payload.countryCode; }
  //   p.otpType = 4; // 1=email, 2=phone, etc.
  //       console.log(this.payload, 'send-paylod');

  //   this._authService.sendOtpToUpdate(p)
  //     .pipe(takeUntilDestroyed(this.destroyRef$))
  //     .subscribe({
  //       next: () => {
  //         this.otpForm.reset();
  //         this.otpTimer = 60;
  //         this.startTimer();
  //       }
  //     });
  // }

  startTimer() {
    this.resendEnabled = false;
    const interval = setInterval(() => {
      if (this.otpTimer > 0) {
        this.otpTimer--;
      } else {
        clearInterval(interval);
        this.resendEnabled = true;
      }
    }, 1000);
  }

  // onSubmit() {
  //   if (this.otpForm.invalid) { this.otpForm.markAllAsTouched(); return; }

  //   const verifyPayload: any = {
  //     otp: this.otpForm.value.otp,
  //     otpType: 4,
  //   };
  //   if (this.payload.email) verifyPayload.email = this.payload.email;
  //   if (this.payload.phone) {
  //     verifyPayload.phone = this.payload.phone;
  //     verifyPayload.countryCode = this.payload.countryCode;
  //   }
  //   console.log(this.payload, 'paylod');
    

  //   this._authService.verifyOtp(verifyPayload)
  //     .pipe(takeUntilDestroyed(this.destroyRef$))
  //     .subscribe({
  //       next: () => this.ref.close({ verified: true }),
  //       error: () => this.ref.close({ verified: false })
  //     });
  // }

  get basePayload() {
  // Normalized payload from parent
  const p = this.config.data || {};
  const out: any = { otpType: 4 };
  if (p.email) out.email = p.email;
  if (p.phone) { out.phone = p.phone; out.countryCode = p.countryCode; }
  return out;
}

resendOtp() {
  this._authService.sendOtpToUpdate(this.basePayload).subscribe({
    next: () => {
      this.otpForm.reset();
      this.otpTimer = 60;
      this.startTimer();
    }
  });
}

onSubmit() {
  if (this.otpForm.invalid) { this.otpForm.markAllAsTouched(); return; }
  const verifyPayload = { ...this.basePayload, otp: this.otpForm.value.otp, deviceType: 'WEB', deviceToken: 'abc' };
  this._authService.verifyOtpToUpdate(verifyPayload).subscribe({
    next: (serverRes) => this.ref.close({ verified: true, server: serverRes }),
    error: () => this.ref.close({ verified: false })
  });

}
}

